/* PanelSignUp.js */
/* @author: anghello */

import React, { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Row } from 'reactstrap';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import WAM from '../../../services/WAM';
import Strings from '../../../translations/Translations';
import PasswordInput from './input/PasswordInput';

export default function PanelSignUp() {
  const history = useHistory();
  const { register, handleSubmit, formState: { errors }, reset } = useForm();
  const [loading, setLoading] = useState(false);

  const onSubmit = useCallback(async ({ username, email, password }) => {
    setLoading(true);

    try {
      const response = await WAM.signup({ un: username, email, pwd: password });

      if (response.result === 'success') {
        toast.success(Strings('user_successfully_created'));
        reset();
        history.replace('/login');
      } else {
        const message = (response && response.error) ? response.error : Strings('error_on_create_user');
        toast.error(message);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast.error(Strings('general_error'));
    }
  }, [setLoading, reset, history]);

  return (
    <>

      <div className='mb-2 mb-0'>
        {/* <small className="text-muted">{Strings('create_your_account')}</small> */}
        <small className="text-muted">&nbsp;</small>
      </div>

      <Form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
        <Row>
          <Col md={12}>
            <FormGroup>
              <input
                type='text'
                name='username'
                placeholder={Strings('username')}
                {...register('username', { required: true })}
                className='form-control pb-input-1 border-radius-4px'
              />
              {errors && errors.username && errors.username.type === 'required' && (
                <p role='alert' className='text-danger txt-small-1'>{Strings('username_is_required')}</p>
              )}
            </FormGroup>
          </Col>
          <Col md={12}>
            <FormGroup>
              <input
                type='email'
                name='email'
                placeholder={Strings('email')}
                {...register('email', { required: true })}
                className='form-control pb-input-1 border-radius-4px'
              />
              {errors && errors.email && errors.email.type === 'required' && (
                <p role='alert' className='text-danger txt-small-1'>{Strings('email_is_required')}</p>
              )}
            </FormGroup>
          </Col>
          <Col md={12}>
            <FormGroup>
              <PasswordInput
                name='password'
                placeholder={Strings('password')}
                {...register('password', { required: true })}
                className='form-control pb-input-1 border-radius-4px'
              />
              {errors && errors.password && errors.password.type === 'required' && (
                <p role='alert' className='text-danger txt-small-1'>{Strings('password_is_required')}</p>
              )}
            </FormGroup>
          </Col>
          <Col md={12} className='mb-4'>
            <div className="text-center p">
              <small>
                {Strings('by_signing_up_you_agree_with_our')} <a href="https://www.photozig.com/privacy_terms.html" target="_blank" rel="noreferrer noopener">{Strings('terms_and_conditions')}</a> / <a href="https://www.photozig.com/privacy_terms.html" target="_blank" rel="noreferrer noopener">{Strings('privacy_policy')}</a>.
              </small>
            </div>
          </Col>
        </Row>

        <Row>
          <div className='d-flex justify-content-center'>
            <Button
              className='pb-btn-1'
              type='submit'
              onClick={handleSubmit(onSubmit)}
              loading={loading}
              disabled={loading}
            >
              {Strings('create_account')}
            </Button>
          </div>
        </Row>
      </Form>
    </>
  );
}
